<template>
  <!-- Komponent select do wyboru typu zdarzenia -->
  <div class="event-type">
    <h4
      class="margin-0"
      :class="{
        // Jeśli występuje błąd i wymagane pole eventTypes nie jest uzupełnione, nagłówek będzie czerwony
        'text-danger':
          this.store.error &&
          (this.store.requireFields.includes('eventTypes') ||
            this.store.requireFields.includes('eventTypes')),
      }"
    >
      {{ t('event-types') }}
    </h4>
    <!-- Select z listą typów zdarzeń -->
    <select class="form-select" name="eventType" v-model.lazy="value">
      <!-- Opcja domyślna: www + preselekcja -->
      <option key="" value="">{{ t('www-and-preselection') }}</option>
      <!-- Opcje zdefiniowane w store.eventTypes (mapowane po kluczu - index) -->
      <option
        v-for="(option, index) in store.eventTypes"
        :key="index"
        :value="index"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
import { watch, ref } from "vue";

export default {
  // Komponent oczekuje przekazania store jako prop
  props: {
    store: { required: true },
  },
  name: "EventTypesFilter",
  setup(props) {
    // Reaktywna wartość – przechowuje wybraną opcję selecta
    const value = ref("");

    // Funkcja do przekazywania wybranej wartości do store'a
    const saveValue = (text) => {
      // console.log('saveValue', text);
      props.store.addItem("eventTypes", text);
    };

    // Watcher na zmianę value – wywołuje saveValue przy każdej zmianie
    watch(value, (newValue) => {
      saveValue(newValue); // tylko po zmianie wartości
    });

    return { value };
  },
};
</script>

<style scoped>
.event-type {
  width: 280px;
}
.event-type h4 {
  /* Wygląd nagłówka sekcji */
  padding: 8px 15px 5px;
  width: 100%;
  background: white;
  font-size: 16px;
  border-right: 1px solid #e1e1df;
}

.event-type select {
  font-size: 12px;
  padding-left: 0.9rem;
}
</style>
